import { scrollAnimation } from './function/scroll-animation.js';
const tile = require('./function/tile.js');
const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/js/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/single-news.scss';